export default __webpack_public_path__ + "static/media/LogoAsset 3@4x.e71bfb85.png";